import { Spinner } from '@volkswagen-onehub/components-core';
import React, { ReactElement } from 'react';

export function LoaderVwView(): ReactElement {
  return <Spinner variant="x-large" />;
}
